import { t } from 'i18next';
import { useTelegramBackButton } from '../../../utils/BackButton';

import { Input } from '../../../components/ui/input';
import { SearchIcon } from '../../../assets/Search';
import { Card } from '../../../components/ui/card';
import { Separator } from '../../../components/ui/separator';
import { Button } from '../../../components/ui/button';
import { FilterIcon } from '../../../assets/Filter';
import { LocationFooterIcon } from '../../../assets/footer/Location';
import { useSearchBranch } from '../services/branchSearch';

import { CardAddressSkelton } from './component/CardSkleton';
import { useCallback, useEffect, useState } from 'react';
import { debounce } from 'lodash';

export const PickupSearch = () => {
  useTelegramBackButton('/restaurants');

  const [searchTerm, setSearchTerm] = useState('');
  const [query, setQuery] = useState('');
  const { branches, isLoading } = useSearchBranch(query);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debounceSearch = useCallback(
    debounce((value: string) => {
      if (value.length >= 3) {
        setQuery(value);
      } else {
        setQuery('');
      }
    }, 300),
    []
  );

  useEffect(() => {
    debounceSearch(searchTerm);
  }, [searchTerm, debounceSearch]);

  return (
    <div className="flex flex-col h-full">
      <p className="text-display-sm text-center">{t('branches-search')}</p>

      <div className="flex-1 overflow-y-auto space-y-[10px] pt-[10px] px-4 pb-28">
        <Input
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
          className="shadow-none border-none bg-text-white rounded-xl max-h-[36px] w-full"
          inputWrapperClassName="w-full"
          placeholder={t('search-branch')}
          iconLeft={<SearchIcon className="text-text-icon-secondary" />}
        />
        {isLoading ? (
          <CardAddressSkelton />
        ) : (
          <Card className="flex flex-col space-y-4 pl-4 pt-3 pb-2 rounded-2xl">
            {branches.map((branch, index) => (
              <div key={index}>
                <div className="flex flex-row items-start justify-between pb-2">
                  <div className="flex flex-col">
                    <p className="text-body-sm-regular">{branch.title}</p>
                    {branch.status && (
                      <p className="text-body-sm-medium text-brand-green">
                        {t('open')}
                      </p>
                    )}
                    <p className="text-body-sm-regular text-text-tertiary">
                      {branch.adress}
                    </p>
                  </div>
                  {/* <p className="text-body-sm-regular text-brand-green pr-[14px] pt-[6px]">
                    {convertKmToM(branch.distance, t)}
                  </p> */}
                </div>
                {index !== branches.length - 1 && <Separator />}
              </div>
            ))}
          </Card>
        )}
      </div>

      <div className="fixed bottom-safe-bottom left-0 right-0 px-4 pb-4 ">
        <div className="flex space-x-2 justify-center">
          <Button className="h-12 bg-white min-w-[60px] rounded-xl">
            <FilterIcon className="text-text-icon-primary" />
          </Button>
          <Button className="h-12 bg-button-primary rounded-xl flex-1 flex flex-row items-center justify-center space-x-1">
            <LocationFooterIcon className="h-6 w-6" />
            <p className="text-display-sm">{t('find-near')}</p>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PickupSearch;
